import React, { FC } from 'react';
import styles from './Loader.module.scss';

const Loader: FC = () => (
  <div className="d-flex">
    <div className={styles.dotPulse} />
  </div>
);
export default Loader;
